import { render } from "./GeneralInformation.vue?vue&type=template&id=fefba880"
import script from "./GeneralInformation.vue?vue&type=script&lang=js"
export * from "./GeneralInformation.vue?vue&type=script&lang=js"

import "./GeneralInformation.vue?vue&type=style&index=0&id=fefba880&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__